import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IAssignDocumentTypeParams {
  fileId: number;
  documentType: string;
}

export async function assignDocumentType({
  fileId,
  documentType,
}: IAssignDocumentTypeParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file/assign-document-type', {
    method: 'POST',
    body: { fileId, documentType },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to assign document type',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
